module.exports = __webpack_public_path__ + "static/media/fuse-background.7fe03983.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Login/assets/fuse-background.png
// module id = 1376
// module chunks = 193